var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle7, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinishProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 277,
    viewBox: "0 0 274 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 216.851,
    cy: 50.6519,
    r: 33.2399,
    fill: "#FFD445"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6148,
    cy: 190.734,
    r: 19.7857,
    fill: "#FFD445"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.048,
    cy: 255.632,
    r: 19.7857,
    fill: "#FFD445"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5232,
    cy: 228.723,
    r: 7.12284,
    fill: "#FFD445"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.214,
    cy: 127.42,
    r: 7.12284,
    fill: "#FFD445"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.666,
    cy: 143.249,
    r: 92.597,
    fill: "#FFD445"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.42 274.758C133.612 274.758 138.632 269.738 138.632 263.546C138.632 257.354 133.612 252.334 127.42 252.334C121.228 252.334 116.208 257.354 116.208 263.546C116.208 269.738 121.228 274.758 127.42 274.758ZM127.42 277C134.851 277 140.874 270.976 140.874 263.546C140.874 256.115 134.851 250.091 127.42 250.091C119.989 250.091 113.966 256.115 113.966 263.546C113.966 270.976 119.989 277 127.42 277Z",
    fill: "#FFD445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4992 25.853C23.5078 31.6216 20.0845 44.3975 25.8531 54.389C31.6216 64.3804 44.3976 67.8037 54.389 62.0351C64.3804 56.2666 67.8037 43.4906 62.0352 33.4992C56.2666 23.5078 43.4906 20.0845 33.4992 25.853ZM27.8595 16.0847C12.4731 24.968 7.20137 44.6424 16.0847 60.0287C24.968 75.4151 44.6424 80.6868 60.0288 71.8035C75.4151 62.9202 80.6868 43.2458 71.8035 27.8594C62.9202 12.4731 43.2458 7.20136 27.8595 16.0847Z",
    fill: "#FFD445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0011 92.2641C15.7599 93.5581 14.9921 96.4238 16.286 98.6649C17.5799 100.906 20.4457 101.674 22.6868 100.38C24.9279 99.0861 25.6958 96.2204 24.4019 93.9792C23.108 91.7381 20.2422 90.9702 18.0011 92.2641ZM17.5325 91.4525C14.8432 93.0053 13.9217 96.4441 15.4744 99.1335C17.0271 101.823 20.466 102.744 23.1554 101.192C25.8447 99.6389 26.7662 96.2 25.2135 93.5106C23.6608 90.8213 20.2219 89.8998 17.5325 91.4525Z",
    fill: "#FFD445"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.463 236.304C139.222 237.598 138.454 240.464 139.748 242.705C141.042 244.946 143.908 245.714 146.149 244.42C148.39 243.126 149.158 240.26 147.864 238.019C146.57 235.778 143.705 235.01 141.463 236.304ZM140.995 235.492C138.306 237.045 137.384 240.484 138.937 243.173C140.49 245.863 143.928 246.784 146.618 245.231C149.307 243.679 150.229 240.24 148.676 237.55C147.123 234.861 143.684 233.94 140.995 235.492Z",
    fill: "#FFD445"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.189 209.934V200.021L123.161 209.934H160.189Z",
    fill: "#AEB5B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.188 156.21L125.143 166.228V152.053L158.188 142.035V156.21Z",
    fill: "#AEB5B6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.363 184.038L122.969 194.056V179.881L160.363 169.863V184.038Z",
    fill: "#AEB5B6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.064 114.589L194.392 102.246L234.702 89.9041V114.589V139.292L194.392 126.95L154.064 114.589Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.299 114.589L89.4643 126.95L48.6299 139.292V114.589V89.9041L89.4643 102.246L130.299 114.589Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.506 230.857C94.0104 230.857 87.9058 224.753 87.9058 217.257H94.8627C94.8627 220.926 97.8367 223.901 101.506 223.901C105.176 223.901 108.15 220.909 108.15 217.257H115.107C115.107 224.753 109.003 230.857 101.506 230.857V230.857Z",
    fill: "#282D33"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.577 230.858C114.081 230.858 107.977 224.753 107.977 217.257H114.933C114.933 220.927 117.908 223.901 121.577 223.901C125.247 223.901 128.221 220.909 128.221 217.257H135.178C135.178 224.753 129.073 230.858 121.577 230.858V230.858Z",
    fill: "#282D33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.665 230.858C134.169 230.858 128.064 224.753 128.064 217.257H135.021C135.021 220.927 137.995 223.901 141.665 223.901C145.335 223.901 148.309 220.909 148.309 217.257H155.266C155.266 224.753 149.161 230.858 141.665 230.858V230.858Z",
    fill: "#282D33"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.754 230.858C154.258 230.858 148.153 224.753 148.153 217.257H155.11C155.11 220.927 158.084 223.901 161.754 223.901C165.423 223.901 168.397 220.909 168.397 217.257H175.354C175.354 224.753 169.25 230.858 161.754 230.858V230.858Z",
    fill: "#282D33"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.841 230.858C174.345 230.858 168.241 224.753 168.241 217.257H175.198C175.198 220.927 178.172 223.901 181.841 223.901C185.511 223.901 188.485 220.909 188.485 217.257H195.442C195.442 224.753 189.338 230.858 181.841 230.858V230.858Z",
    fill: "#282D33"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M162.005 139.384L155.065 139.868L159.95 209.893L166.89 209.409L162.005 139.384Z",
    fill: "#282D33"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.333 139.383L116.46 209.409L123.401 209.891L128.273 139.866L121.333 139.383Z",
    fill: "#282D33"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.884 142.401H116.447V121.53H166.884V142.401ZM123.404 135.444H159.927V128.487H123.404V135.444Z",
    fill: "#282D33"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156.449 109.354H126.882V125.008H156.449V109.354Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.928 128.486H123.404V105.876H159.928V128.486ZM130.361 121.529H152.971V112.833H130.361V121.529Z",
    fill: "#282D33"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160.189 109.407L141.666 97.0068L123.143 109.407L119.282 103.633L141.666 88.6411L164.067 103.633L160.189 109.407Z",
    fill: "#282D33"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171.824 206.456H111.525V213.413H171.824V206.456Z",
    fill: "#282D33"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.144 116.016H138.187V125.286H145.144V116.016Z",
    fill: "#282D33"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.874,
    cy: 144.04,
    r: 107.634,
    stroke: "#363853",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "6 10"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.86 110.141C56.0522 110.141 61.0719 105.121 61.0719 98.9289C61.0719 92.7368 56.0522 87.717 49.86 87.717C43.6679 87.717 38.6481 92.7368 38.6481 98.9289C38.6481 105.121 43.6679 110.141 49.86 110.141ZM49.86 112.383C57.2906 112.383 63.3143 106.36 63.3143 98.9289C63.3143 91.4983 57.2906 85.4747 49.86 85.4747C42.4294 85.4747 36.4058 91.4983 36.4058 98.9289C36.4058 106.36 42.4294 112.383 49.86 112.383Z",
    fill: "#FFD445"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishProcess);
export default __webpack_public_path__ + "static/media/FinishProcess.6ca050f05c43e426429c0a28a47ba24b.svg";
export { ForwardRef as ReactComponent };